'use client';

import config from '@/config';
import { ArrowRight } from 'lucide-react';
import mixpanel from 'mixpanel-browser';

export default function AltCTA() {
  return (
    <section className="relative overflow-hidden bg-ink-900 text-paper-50">
      <div
        className="absolute inset-0 opacity-[0.06] pointer-events-none"
        style={{
          backgroundImage:
            'radial-gradient(circle at 1px 1px, #FDFAF3 1px, transparent 0)',
          backgroundSize: '22px 22px',
        }}
      />

      <div className="relative max-w-3xl mx-auto px-6 lg:px-8 py-20 lg:py-28 text-center">
        <p className="font-hand text-brand-300 text-2xl mb-4 -rotate-2 inline-block">
          your questions, their race
        </p>
        <h2 className="font-display font-black text-4xl md:text-6xl tracking-[-0.02em] leading-[1.02]">
          Run Friday&apos;s review{' '}
          <span className="italic font-medium text-brand-300">as a race.</span>
        </h2>
        <p className="mt-6 font-display text-lg text-paper-50/80 leading-relaxed max-w-xl mx-auto">
          Bring one quiz you already have. If your class does not ask to play
          again, go back to the podium.
        </p>

        <div className="mt-10">
          <a
            className="btn btn-primary btn-lg rounded-full px-10 text-white shrink-button btn-letterpress"
            href={`${config.appUrl}/register`}
            onClick={() =>
              mixpanel.track('kahoot_alt_cta_clicked', {
                location: 'footer_cta',
              })
            }
          >
            Create your first race
            <ArrowRight className="w-5 h-5" />
          </a>
          <p className="font-display text-paper-50/55 text-sm mt-5">
            Free to use &middot; no credit card
          </p>
        </div>
      </div>
    </section>
  );
}
